export const Currency = {
    'USD': 'USD',
    'EUR': 'EUR',
    'KRW': 'KRW',
    'CNY': 'CNY'
}
